/**
 * voice-v8 — die Teile EINES langen Diktats zu einem Text. (29.09.2026,
 * Ticket 2618)
 *
 * Die Sprechtaste wechselt an ihrer Höchstdauer nahtlos in einen neuen Teil
 * (frontend/lib/diktat-teile.ts); jeder Teil wird für sich erkannt, weil
 * eine Anfrage nicht größer werden darf (nginx 20 MB, siehe
 * SERVER_ANNAHME_MB in shared/limits.ts). Seite und Server fügen die Texte
 * mit DIESER Regel zusammen: der Reihe nach, mit einem Leerzeichen, leere
 * Teile fallen weg.
 *
 * ⚠️ Kein Punkt, kein Absatz: der Schnitt liegt nach der Uhr, meist mitten
 *    im Satz („… dass die Ärzte natürlich wissen, wie" | „sie das …").
 */
export function verbindeTeile(...teile: readonly string[]): string {
  return teile
    .map((t) => t.trim())
    .filter((t) => t !== "")
    .join(" ");
}
